import React from 'react'
import ReactDOM from 'react-dom/client'
import './prg.css'
import Prg from './prg'
const root = ReactDOM.createRoot(document.getElementById('prg-root'))
root.render(<Prg />)
